import React from 'react';

import { useLocation } from 'react-router-dom';

import styles from './AppFooter.module.scss';
import { Twitter, Youtube, Facebook, Instagram, Linkedin } from 'assets/landing/index';
import textStyles from 'common/styles/text.module.scss';

const Footer = (): React.ReactElement => {
  const location = useLocation();
  const isLanding = location.pathname == '/';

  return (
    <div className={`${isLanding ? styles.footerLanding : styles.footerExplore}`}>
      <div className={`pt-5 ${styles.colContainer}`}>
        <div>
          <p
            className={textStyles['text-primary-12-400']}
            style={{
              textAlign: 'center',
            }}
          >
            © 2022 UNIFY. ALL RIGHTS RESERVED
          </p>
        </div>
        <div className="d-flex flex-row mt-2">
          {/* <a href=""> */}
          <u className={textStyles['text-secondary-11-400']} style={{ textAlign: 'center' }}>
            <p className={styles.aboutText}>Condition of Use</p>
          </u>
          {/* </a> */}
          <a
            href="https://blog.unifyapply.com/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.link}
          >
            <u className={textStyles['text-secondary-11-400']} style={{ textAlign: 'center' }}>
              <p className={styles.aboutText}>Privacy Notice</p>
            </u>
          </a>
          {/* <a href=""> */}
          <u className={textStyles['text-secondary-11-400']} style={{ textAlign: 'center' }}>
            <p className={styles.aboutText}>About</p>
          </u>
          {/* </a> */}
        </div>
        <div className="d-flex flex-row mt-3 mb-4">
          <a
            href="https://www.youtube.com/channel/UCkSIfjCtMT3oUZltdwejcfg"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Youtube} className={styles.imageSocialContainer} alt="youtube" />
          </a>
          <a href="https://twitter.com/unify_apply" target="_blank" rel="noopener noreferrer">
            <img src={Twitter} className={styles.imageSocialContainer} alt="twitter" />
          </a>
          <a href="https://www.facebook.com/unifyapply" target="_blank" rel="noopener noreferrer">
            <img src={Facebook} className={styles.imageSocialContainer} alt="facebook" />
          </a>
          <a href="https://www.instagram.com/unifyapply/" target="_blank" rel="noopener noreferrer">
            <img src={Instagram} className={styles.imageSocialContainer} alt="instagram" />
          </a>
          <a
            href="https://www.linkedin.com/company/unifyapply/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Linkedin} className={styles.imageSocialContainer} alt="linkedin" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
